/* eslint-disable no-unused-expressions */
import React, { useEffect, useRef } from 'react';
import { shallowEqual, useSelector } from 'react-redux';
import block from 'bem-cn';

import Button from 'components/Button';
import SVG from 'components/SVG';

import crossSVG from '../../img/cross.svg';
import useImageInput from '../../model/useImageInput';

import './InputPhoto.scss';

const b = block('input-photo-mobile');

const InputPhoto = ({ currentImageData, name, onImageChange, url, text, iconSize, altLayout, ...restProps }) => {
  const locale = useSelector(state => state.locale.locale, shallowEqual);
  const ref = useRef(null);

  const withImage = Boolean(currentImageData.image);

  const handleImgChange = useImageInput();

  useEffect(() => {
    const handleUrlLoad = async () => {
      if (url) {
        try {
          const response = await fetch(url);

          if (!response.ok) {
            throw new Error('Ошибка сети');
          }

          const data = await response.blob();

          let mimeType = data.type;

          const file = new File([data], 'img', { type: mimeType });
          const imageData = await handleImgChange(file);
          if (onImageChange && imageData.image) onImageChange(imageData);
        } catch (error) {
          console.error('Ошибка загрузки изображения:', error);
        }
      }
    };

    handleUrlLoad();
  }, [url]);

  const handleDragPrevent = e => {
    e.preventDefault();
    e.stopPropagation();
  };

  const handleClickPrevent = e => {
    e.preventDefault();
    e.stopPropagation();
  };

  const handleImageDrop = async e => {
    e.preventDefault();
    e.stopPropagation();
    const imageData = await handleImgChange(e.dataTransfer.files);
    if (onImageChange) onImageChange(imageData);
  };

  const handleFileChange = async e => {
    const imageData = await handleImgChange(e.currentTarget.files);
    if (onImageChange) onImageChange(imageData);
  };

  const handleImageDelete = e => {
    e.preventDefault();
    e.stopPropagation();

    if (ref.current) ref.current.value = '';

    onImageChange({
      ext: '',
      image: null,
      error: null,
    });
  };

  return (
    <label
      className={b({ withImage: withImage && altLayout })}
      onDragEnter={handleDragPrevent}
      onDragOver={handleDragPrevent}
      onDrop={handleImageDrop}>
      <input
        className={b('native')}
        type="file"
        name={name}
        accept=".jpeg,.png,.jpg,.gif,.webp"
        onChange={handleFileChange}
        ref={ref}
        {...restProps}
      />
      {currentImageData.image || url ? (
        <img
          className={b('img', { withImage: withImage && altLayout })}
          src={currentImageData.base64 || url}
          alt="img"
          onClick={handleClickPrevent}
        />
      ) : (
        <SVG className={b('cross', { iconSize })} svgProps={{ svg: crossSVG }} />
      )}
      {!withImage && <div className={b('text')}>{text || locale.selectFile}</div>}
      {/* (
        <>
          <div className={b('buttons')}>
            <div className={b('button')}>
              <Button color="hollow-red" onClick={handleImageDelete}>
                {locale.delete}
              </Button>
            </div>
            <div className={b('space')} onClick={handleClickPrevent} />
            <div className={b('button')}>
              <Button color="hollow-blue" onClick={() => ref.current?.click()}>
                {locale.loadOther}
              </Button>
            </div>
          </div>
        </>
      ) */}
    </label>
  );
};

export default InputPhoto;
